const styles = (theme) => ({
  tableHeadDelayStop: {
    backgroundColor: theme.delayHeadColor,
  },
  tableHead: {
    backgroundColor: theme.headColor,
  },
  tableHeadHeight: {
    height: "52px",
    "& $tableHeaderCell": {
      paddingTop: "6px",
    },
  },
  headerContainer: {
    display: "flex",
    alignItems: "flex-start",
  },
  pickupMarkerHeight: {
    height: 58
  },
  pickupMarker: {
    float: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingRight: "6px",
    marginTop: 5,
    paddingLeft: 10,
  },
  tableHeaderCell: {
    color: theme.headFontColor,
    borderBottom: 0,
    fontSize: "12px",
  },
  accountNumber: {
    float: "right",
    fontSize: "12px",
    paddingRight: "8px",
  },
  clickable :{
    textDecoration : "underline"
  },
  nameContainer: {
    height: "20px",
  },
  mergeNameWrap: {
    display: "flex",
    alignItems: "center",
    "& $name": {
      float: "none",
      minWidth: 0,
      width: "auto",
      maxWidth: "210px",
    },
  },
  maxWidth: {
    minWidth: "232px",
  },
  address: {
    clear: "both",
    fontSize: "10px",
    lineHeight: "20px",
    color: theme.address,
    paddingLeft: "12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "232px",
    textOverflow: "ellipsis",
    display: "inline-block",
  },
  name: {
    float: "left",
    paddingLeft: "12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    lineHeight: "17px",
    width: "130px",
    textOverflow: "ellipsis",
  },
  pickupPriority: {
    color: theme.ModalBGColor, 
    fontSize: 20,
    marginTop: 2,
  }
});

export default styles;
